<template lang="pug">
//- 個人資訊
.profile-index.page-Index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop

  .profile-top.row
    .col-3
      .profile-title 個人資訊
    .col-9.pro-col
      .row
        .col-auto
          .profile-info
            .info-title 互動直播餘額
            .info-text {{ $root.common.formatNumber($root.user.total_point, 0) }}
        .col-auto
          .profile-info
            .info-title 禮讚直播餘額
            .info-text {{ $root.common.formatNumber($root.user.live_point, 0) }}
        .col-auto
          .profile-info
            .info-title 扣點方式
            .info-text
              .cut-item(v-if="$root.user.is_anyschool") 超優歡樂頌
              .buy-item(v-else) 單堂扣點
        .col-auto
          .profile-info
            .info-title 到期日
            .info-text {{ $root.user.date_end }}
        //- .col-auto
          .profile-info
            .info-title 預約課程
            .info-text 14
        //- .col-auto
          .profile-info
            .info-title 完成課程
            .info-text 30
  //- profile-tab
  .profile-tab
    .tab-item.click-cursor(
      v-for="(tab,index) in profile_tab",
      :class="tab.tab_status ? 'tab-active' : 'tab-noactive'",
      @click="changeTab(index)"
    ) {{ tab.text }}
    .clearfix

  //- 切換內容
  .profile-content
    //- 基本資料
    TabOneContent(v-if="profile_tab[0].tab_status", :user="$root.user")
    //- 歷史課程
    TabThreeContent(v-if="profile_tab[1].tab_status")
    //- 互動點數紀錄
    TabFourContent(v-if="profile_tab[2].tab_status", @goTop="goTop")
    //- 直播點數紀錄
    TabFiveContent(v-if="profile_tab[3].tab_status", @goTop="goTop")
    //- 點數購買紀錄
    //- TabSixContent(v-if="profile_tab[4].tab_status", @goTop="goTop")
    //- 點數購買
    //- TabTwoContent(v-if="profile_tab[5].tab_status")
</template>
<script>
import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import TabOneContent from '@/components/profile/tab-1-profile'
import TabTwoContent from '@/components/profile/tab-2-buypoint'
import TabThreeContent from '@/components/profile/tab-3-history'
import TabFourContent from '@/components/profile/tab-4-record-active'
import TabFiveContent from '@/components/profile/tab-5-record-live'
import TabSixContent from '@/components/profile/tab-6-record-buy'

export default {
  name: 'Index',
  components: {
    ContentTop,
    TabOneContent,
    TabTwoContent,
    TabThreeContent,
    TabFourContent,
    TabFiveContent,
    TabSixContent
  },
  data () {
    return {
      profile_tab: [
        {
          text: '基本資料',
          tab_status: true,
        },

        {
          text: '歷史課程',
          tab_status: false,
        },
        {
          text: '互動點數紀錄',
          tab_status: false,
        },
        {
          text: '直播點數紀錄',
          tab_status: false,
        },
        // {
        //   text: '購買點數紀錄',
        //   tab_status: false,
        // },
        // {
        //   text: '點數購買',
        //   tab_status: false,
        // },
      ]
    };
  },
  async created () {
    // 請求進行更新學員資料
    await this.$root.apis.getSystemInfo()
    // 關閉載入中畫面
    await this.$root.closeLoading()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    //- 回至頂部
    goTop () {
      $('.profile-index').animate({
        scrollTop: 0
      }, 200)
    },
    changeTab (_index) {
      this.profile_tab.forEach(function (_item) {
        _item.tab_status = false
      })
      this.profile_tab[_index].tab_status = true
    }
  }
}
</script>
<style lang="sass">
</style>
